import { useTranslation } from 'react-i18next'
import { CallbackDates } from 'src/types'
import { toDate, toHour } from 'src/utils'

export const useNextSteps = ({ callbackDates }: { callbackDates?: CallbackDates }) => {
  const { t } = useTranslation()

  const startDate = callbackDates?.dataInizio
    ? toDate(callbackDates?.dataInizio) || ''
    : callbackDates?.dataEmissione
    ? toDate(callbackDates?.dataEmissione) || ''
    : ''

  const startHour = callbackDates?.dataInizio
    ? toHour(callbackDates?.dataInizio) || ''
    : callbackDates?.dataEmissione
    ? toHour(callbackDates?.dataEmissione) || ''
    : ''

  const fills = {
    startDate,
    startHour,
    endDate: toDate(callbackDates?.dataFine) || '',
    endHour: toHour(callbackDates?.dataFine) || '',
  }

  return {
    t,
    fills,
  }
}
